module.exports = __webpack_public_path__ + "static/img/kf2.2ab3e459.png";